import { GoogleMedia } from "@/model/googlemedia.model";

export default class MediaUtils {

    constructor() {
    }

    formatTime(totalSeconds: number) {
      const minutes = Math.floor(totalSeconds % 3600 / 60);
      const seconds = Math.floor(totalSeconds % 3600 % 60);
      let result = '';
      result += this.padTime(String(minutes));
      result += ':'
      result += this.padTime(String(seconds));
      return result;
    }

    padTime(value: string) {
      if (value.length > 2) {
        value = value.substring(0, 1);
      }
      if (value.length < 2) {
        value = '0' + value;
      }
      return value;
    }

    getTotalPlaylistDuration(tracks: Array<GoogleMedia>): number {
      if (!tracks || !Array.isArray(tracks)) return 0;
      let totalDuration = 0;
      tracks.forEach((t) => {
        totalDuration += t.duration;
      })

      return totalDuration;
    }

    getTotalPlaylistDurationFromIndex(tracks: Array<GoogleMedia>, fromIdx: number): number {
      if (!tracks || !Array.isArray(tracks)) return 0;
      let totalDuration = 0;
      tracks.forEach((t, index) => {
        if (index >= fromIdx) {
          totalDuration += t.duration;
        }
      })

      return totalDuration;
    }

    computedTrackName(name: string): string {
      if (name && name !== '') {
          try {
              const fileName = name.split('.')[0];
              const fileNameParts = fileName.split('_');
              
              return fileNameParts[fileNameParts.length - 1];
          } catch(ex) {
              //ignore
              console.log(ex);
          }
          return name;
      } else {
          return '';
      }
    }

    getTrackName(track: GoogleMedia): string {
      const computedName = this.computedTrackName(track.name);
      // const titleTag = this.getAudioTag(track, 'TIT2');
      
      return `${computedName}`;
    }

    getTrackNameShort(track: GoogleMedia): string {
      const computedShortName = this.computedShortName(track.name);
      // const titleTag = this.getAudioTag(track, 'TIT2');

      return `${computedShortName}`;
    }

    computedShortName(name: string): string {
      if (name && name !== '') {
          try {
              const fileName = name.split('.')[0];
              const fileNameParts = fileName.split('_');

              return `${fileNameParts[fileNameParts.length - 1]}`;
          } catch(ex) {
              //ignore
              console.log(ex);
          }
          return name;
      } else {
          return '';
      }
    }

    getAudioTag(track: GoogleMedia, tag: string): string {
      try {
        if (track.tags) {
          const tagsJson = JSON.parse(track.tags);
          if (tagsJson[tag]) {
            return String(tagsJson[tag]);
          }
        }
      } catch(ex) {
        //ignore
        console.log(ex);
      }
      return '';
    }
}